import { render } from "./SessionWarning.vue?vue&type=template&id=4b82bb70&scoped=true"
import script from "./SessionWarning.vue?vue&type=script&lang=js"
export * from "./SessionWarning.vue?vue&type=script&lang=js"

import "./SessionWarning.vue?vue&type=style&index=0&id=4b82bb70&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b82bb70"]])

export default __exports__